import type { QueryClient } from "@tanstack/react-query";

import { ACTIVATION_OBJECTS_QUERY_KEY } from "app/pages/activation/queries/data/useActivationSetListQuery";
import type { ProjectsResponseSchema } from "app/pages/activation/types/api";

type UpdateBooleanInActivationItemSchema = {
    itemId: string;
    queryClient: QueryClient;
    objectKey: string;
    value?: boolean;
    resetOther?: boolean;
};

export const updateBooleanInActivationItem = ({
    itemId,
    objectKey,
    value,
    queryClient,
    resetOther,
}: UpdateBooleanInActivationItemSchema) => {
    const data: ProjectsResponseSchema = queryClient.getQueryData([ACTIVATION_OBJECTS_QUERY_KEY]);

    const updatedItems = data.activationSets.map((item) => {
        if (item.id === itemId) {
            return { ...item, [objectKey]: value ?? !item[objectKey] };
        }

        return resetOther ? { ...item, [objectKey]: false } : item;
    });

    queryClient.setQueryData([ACTIVATION_OBJECTS_QUERY_KEY], {
        ...data,
        activationSets: updatedItems,
        manuallyUpdated: true,
    });
};
